var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "url(#pattern0_1187_765)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1187_765",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1187_765",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1187_765",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAACD0lEQVR4nO2WT0hVQRTGf/0n1IKwWmQuwoXPgpbhylKC3Ig+XYS4iDaCPWyVoa3yrQQ3RiREuG9VKLxd7kV8SkLQRiSklVhZCVb64sB3YYjevTffzCJ4H8zmzjfn++7MmXMGqqjiP8Q5IA8sA980isA4cDa0eB+wDZTKjC9ANqT4voReAW1AjcZ14LXm9oCeENu+LYEHMbyH4nwG6n0ayDt/noRZcR/7NLCioLbtSbghriWmN3xV0NoU3Dpx7ci84dM/GDgl7pZPA0sKatmehHZxF30aeKSgdtWSMCfumE8D54FNBbarVg6j4mzq6npFN/BLArPK9lqNdufPjdNFIGSdavi38WcVvOBTvBdYjxGPxnvguNYUgOZKhQ8DTxyBVeA+cFl94CSQAXLAW+Cl1mW0W9OVGpiS8C4wJENxZqMeMK111q7PVNIBSxK3REsLE/zu7NrIQcRPAB8UYCiF4BWgE7irYyg56zeAYeVRK9AAHEsycNs58yMxvFzMzbgFvCsztwCcjjMQ/YUlXBL6dUzG/wFMAIPAIeCaClTRES+k6StrIreQDh16ktmaN+qKEe4APzU3AxxNE3BHC9xASbjqVMtG58ZEz7Xn2pVguOj0ggEl4Qvgqb5PEhg9CVVyPrSBcUfsI3DPeSNGj9WgR1DQbbDqaS+jCFbErEybiaaQBp4Bl8rMWeZbMbrpfv0NgqCxL0ZLy/kAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionals);
export default __webpack_public_path__ + "static/media/professionals.65f778ab58005c3e74d3dba5cff572c4.svg";
export { ForwardRef as ReactComponent };